import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetOfferReportings } from '../../hooks/react-query/useAdmin';
import { Mapper } from '../../utils/user/mapper';
import { Table } from '../../components/ui/Table';
import { PageTitle } from '../../components/ui';
import { HeaderToolBar } from '../../components/elements/headerToolBar';
import Pagination from '../../components/elements/pagination/pagination';

import {
  exportToFile,
  generatePdfDocument,
} from '../../utils/importDriver/funtions';
import { TableSkeletion } from '../../components/elements/skeletions';
import Container from '../../components/elements/container';
import { LeftArrow } from '../../icons';
import {
  TableBodyComponent,
  TableHeadersComponent,
} from '../../components/admin/table';
import Loader from '../../components/elements/loader';
import { NoDataFound } from '../../components/elements/noDataFound';

const OfferReporting = () => {
  const navigate = useNavigate();
  const [offerList, setAllOfferList] = useState();
  const [offerReportingList, setOfferReportingList] = useState();
  const [openColumnListModal, setCoumnListModal] = useState(false);
  const [selectedColumns, setSavedColumns] = useState([]); //

  const [filterState, setFilterState] = useState({
    length: -1,
    orderBy: '',
    search: undefined,
    page: 1,
    orderType: 'asc',
  });

  const { data: offerReportingData, isFetching } =
    useGetOfferReportings(filterState);

  useEffect(() => {
    if (
      offerReportingData &&
      offerReportingData.pages &&
      offerReportingData.pages[0].data
    ) {
      const offerReportsList = Mapper(
        offerReportingData.pages[0],
        'offerReporting'
      );
      setOfferReportingList(offerReportsList);
      if (!offerList || (offerList && !offerList.data?.length)) {
        setAllOfferList(offerReportsList);
      }
    }
  }, [offerReportingData]);

  const handleExport = (type) => {
    if (type === 'pdf') {
      generatePdfDocument(offerList, 'Offers Reporting', 6); // fontSize: 6
    } else {
      exportToFile(offerList, type, 'offersreporting');
    }
  };

  const handleSortOrder = (item) => {
    let orderBy = item.name;
    let orderType = 'asc';
    if (item.name !== filterState?.orderBy) {
      orderBy = item.name;
    } else {
      orderType = filterState.orderType === 'asc' ? 'desc' : orderType;
    }

    setFilterState((prev) => ({ ...prev, orderType, orderBy, page: 1 }));
  };

  const handleSearch = (searchKey) => {
    setFilterState((prev) => ({ ...prev, search: searchKey, page: 1 }));
  };

  const handlePagination = (pageNum) => {
    setFilterState((prev) => ({ ...prev, page: pageNum }));
  };

  const handleColumnSave = (columns) => {
    setSavedColumns(columns);
    setCoumnListModal(false);
  };

  const handlePerPageDataFetch = (value) => {
    setFilterState((prev) => ({ ...prev, length: value }));
  };


  return (
    <>
      {isFetching && <Loader />}
      <Container className="flex flex-col gap-6 overflow-y-auto max-h-[88vh] max-lg:px-0">
        <PageTitle
          displaySearch={false}
          wrapperClassName="flex-col max-lg:px-5"
          title={
            <div className="flex max-lg:gap-x-8 items-center">
              <button className='lg:p-2' type="button" onClick={() => navigate('/dashboard')}>
                <LeftArrow width={24} height={24} />
              </button>
              <h2 className="self-center"> Offers Reportings</h2>
            </div>
          }
          endComponent={
            <HeaderToolBar
              showPageList={false}
              dataPerPageCount={filterState?.length}
              openColumnListModal={openColumnListModal}
              handleSearch={handleSearch}
              searchTerm={filterState.search}
              configurations={offerReportingList}
              columnList={offerReportingList?.columns}
              handleExport={handleExport}
              selectedColumns={selectedColumns}
              handleColumnSave={handleColumnSave}
              handleColumnListClick={(value) => setCoumnListModal(value)}
              handlePerPageDataFetch={handlePerPageDataFetch}
            />
          }
        />
        {filterState.search === undefined ? (
          <NoDataFound
            className="p-5 lg:p-8 flex align-center justify-center"
            title={
              'Search an Offer using the unique Offer Code e.g. DHF12345 or User’s Tax Code e.g 238923742379'
            }
          />
        ) : !isFetching && offerReportingList!== undefined && (
          <>
            <Table wrapperClassName="p:2 lg:p-4 scrollbar overflow-auto max-lg:rounded-none max-lg:min-h-[250px]">
              <TableHeadersComponent
                selectedColumns={selectedColumns}
                tableData={offerReportingList}
                handleSortOrder={handleSortOrder}
              />
              <TableBodyComponent
                tableData={offerReportingList}
                selectedColumns={selectedColumns}
              />
            </Table>

            <Pagination
              currentPage={offerReportingList?.pagination?.current_page}
              totalCount={offerReportingList?.records?.total}
              from={offerReportingList?.records.from}
              to={offerReportingList?.records.to}
              pageSize={filterState.length || 25}
              onPageChange={handlePagination}
            />
          </>
        )}
      </Container>
    </>
  );
};

export default OfferReporting;
